import { getRequest, postRequest } from "./api";
import store from "../redux/store";

export const checkChannelStatus = async (channelId, token) => {
  const { organizationId, accountId, setupId, agentId } = store.getState().info;

  const searchParams = new URLSearchParams();

  searchParams.set("channelId", channelId);
  searchParams.set("organizationId", organizationId);
  searchParams.set("accountId", accountId);
  searchParams.set("workspaceId", setupId);
  searchParams.set("agentId", agentId);

  const endpoint = `snippet/channel-status?${searchParams.toString()}`;
  const response = await getRequest({ endpoint, token });
  if (!response) {
    return null;
  }
  const data = await response.json();
  return data;
};

export const getSetupInfo = async (
  organizationId,
  accountId,
  setupId,
  token,
  channelId,
  accountName,
  setupName,
  agentName,
  agentId,
  agentLanguage = "en-US"
) => {
  var endpoint = "snippet/info";
  endpoint += `?organizationId=${organizationId}`;
  endpoint += `&accountId=${accountId}`;
  endpoint += `&workspaceId=${setupId}`;
  endpoint += `&channelId=${channelId}`;

  endpoint += accountName ? `&accountName=${accountName}` : "";
  endpoint += setupName ? `&workspaceName=${setupName}` : "";
  endpoint += agentName ? `&agentName=${agentName}` : "";
  endpoint += agentId ? `&agentId=${agentId}` : "";
  endpoint += agentLanguage ? `&agentLanguage=${agentLanguage}` : "";

  const response = await getRequest({ endpoint, token });
  const setupInfo = await response.json();
  return setupInfo;
};

export const saveSetupInfo = async (setupInfo, token) => {
  const endpoint = "mb/setup";
  const response = await postRequest({ endpoint, token, data: setupInfo });
  // TODO: Handle error response
  if (!response.ok) {
    return { success: false, message: "An error occurred while saving the setup. Please try again shortly." };
  }
  return { success: true, message: "Setup info saved successfully" };
};
